/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC } from "react";
import { BEM, SYSTEM_COLOR } from "@adapptio/lib-components";
import { isNil } from "@adapptio/lib-shared";

export enum BADGE_VARIANT {
	STANDARD = "standard",
	DOT = "dot"
}

export enum BADGE_POSITION {
	START = "start",
	END = "end"
}

export interface IBadgeProps {
	className?: string;
	variant?: BADGE_VARIANT;
	content?: React.ReactNode;
	color?: SYSTEM_COLOR;
	position?: BADGE_POSITION;
}

export const Badge: FC<IBadgeProps> = ({ children, className, variant, content, color, position }) => {
	const baseClass = BEM("edt-badge", null, {
		variant,
		color,
		position
	});

	if (className) {
		baseClass.add(className);
	}

	return (
		<span className={baseClass.toClassName()}>
			{children}
			{!isNil(content) && <span className={baseClass.element("content").toClassName()}>{content}</span>}
		</span>
	);
};

Badge.defaultProps = {
	variant: BADGE_VARIANT.STANDARD,
	color: SYSTEM_COLOR.INFO
};
